import { render, staticRenderFns } from "./CommentField.vue?vue&type=template&id=2999b2ac&scoped=true"
import script from "./CommentField.vue?vue&type=script&lang=js"
export * from "./CommentField.vue?vue&type=script&lang=js"
import style0 from "./CommentField.vue?vue&type=style&index=0&id=2999b2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2999b2ac",
  null
  
)

export default component.exports